import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AppclipState {
  partnerName: string;
  programName: string;
  slug: string;
  loading: boolean;
}

const initialState: AppclipState = {
  partnerName: '',
  programName: '',
  slug: '',
  loading: false,
};

const { actions, reducer } = createSlice({
  name: 'AppclipState',
  initialState,
  reducers: {
    setDetails: (state, action: PayloadAction<Omit<AppclipState, 'loading'>>) => {
      const { payload } = action;

      state.partnerName = payload.partnerName;
      state.programName = payload.programName;
      state.slug = payload.slug;
    },

    setLoading: (state, action: PayloadAction<boolean>) => {
      const { payload } = action;
      state.loading = payload;
    },
  },
});

export const appclipActions = {
  ...actions,
};

export const appclipReducer = reducer;
